import { render, staticRenderFns } from "./UserAccessLogs.vue?vue&type=template&id=7c18f5c5&lang=pug"
import script from "./UserAccessLogs.vue?vue&type=script&lang=js"
export * from "./UserAccessLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c18f5c5')) {
      api.createRecord('7c18f5c5', component.options)
    } else {
      api.reload('7c18f5c5', component.options)
    }
    module.hot.accept("./UserAccessLogs.vue?vue&type=template&id=7c18f5c5&lang=pug", function () {
      api.rerender('7c18f5c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tableau/UserAccessLogs.vue"
export default component.exports